import type {SxProps} from '@mui/material';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import {type FC, useState} from 'react';
import {type Field, FieldListView, MapView, type Survey} from 'talptech-gis-components';
import Layout from '../components/Layout';

const FieldMapPage: FC = () => {
  const [selectedField, setSelectedField] = useState<Field>();
  const [selectedSurvey, setSelectedSurvey] = useState<Survey>();

  const sidePanelContent = (
    <Stack sx={styles.wrapper}>
      <Box sx={styles.content}>
        <FieldListView selectedField={selectedField} onSelectedField={setSelectedField} />
      </Box>
    </Stack>
  );

  const mainContent = (
    <Box sx={{flex: 1}}>
      <MapView
        selectedField={selectedField}
        onSelectedField={setSelectedField}
        selectedSurvey={selectedSurvey}
        onSelectedSurvey={setSelectedSurvey}
      />
    </Box>
  );

  return <Layout sidePanelContent={sidePanelContent} mainContent={mainContent} closeSidePanelOn={selectedField} />;
};

export default FieldMapPage;

const styles: Record<string, SxProps> = {
  wrapper: {
    height: '100%',
    overflow: 'hidden',
  },
  content: {
    flexGrow: 1,
    overflow: 'auto',
  },
};
